export enum DatafieldsEnum {
    TEXT = 1,
    NUMBER,
    BOOLEAN,
    CHECKLIST,
    DATE,
    HOUR,
    RANGE,
    IMAGE
}